import { defineNuxtRouteMiddleware } from '#imports'
import { createNavigationGuard } from '@utils/navigation-guard'
import { asRouteMiddleware, noteFirstNavigation } from '@utils/route-guards'

const navigationGuard = asRouteMiddleware(createNavigationGuard())

// Global middleware runs before a route's own, as the router's global guard ran before
// `beforeEnter`: it has to remember a signed-out visitor's destination before `auth`
// sends them to login. It also runs on the first page load, unlike a guard added from
// a plugin.
export default defineNuxtRouteMiddleware((to, from) => {
    noteFirstNavigation(to)
    return navigationGuard(to, from)
})
